import { Button, type ButtonProps } from '@arkestro/arkestro-design-system';

export const PrimaryButton = ({
  block,
  children,
  className,
  disabled,
  ghost,
  loading,
  onClick,
  shape,
  size,
  style,
  type = 'primary',
  htmlType = 'button',
}: ButtonProps) => (
  <Button
    block={block}
    className={className}
    disabled={disabled}
    ghost={ghost}
    htmlType={htmlType}
    loading={loading}
    onClick={onClick}
    shape={shape}
    size={size}
    style={style}
    type={type}
  >
    {children}
  </Button>
);
